import { Component, inject, OnInit } from '@angular/core';
import { AppInformationService, AuthService, BrewersUnitOfWork } from 'app/core/core.module';
import { InvoiceLine, Product, ProductMaterial, ProductUnitOfMeasure } from 'app/core/model/entity-model';
import DataSource from 'devextreme/data/data_source';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    standalone: false,
    selector: 'app-invoice-line-dialog',
    templateUrl: './invoice-line-dialog.component.html',
    styleUrls: ['./invoice-line-dialog.component.scss'],
})
export class InvoiceLineDialogComponent implements OnInit {
    uow = inject(BrewersUnitOfWork);
    auth = inject(AuthService);
    appInfo = inject(AppInformationService);

    result = new Subject<{ success: boolean; value?: InvoiceLine }>();
    mode?: 'delivery';
    quantity: number = null;
    invoiceLine: InvoiceLine;
    invoiceId: number;
    lineNumber: number;
    productsDS: DataSource;
    products: Product[];
    uoms: ProductUnitOfMeasure[];

    async ngOnInit() {
        await this.appInfo.pleaseWaitShow();
        if (!this.invoiceLine) {
            this.invoiceLine = this.uow.invoiceLines.createEntity({
                quantity: this.quantity,
                price: null,
                invoiceId: this.invoiceId,
                lineNumber: this.lineNumber,
                created: new Date(),
                createdBy: this.auth.currentUser.userName,
            });
        }

        this.uoms = await this.uow.productUnitsOfMeasure.whereActive();

        const materialId = this.mode === 'delivery' ? ProductMaterial.Materials.Delivery : null;
        const products = await this.uow.getProducts(materialId);
        // exclude generic delivery product
        this.products = products.filter(product => product.id !== Product.Types.Delivery);
        this.productsDS = new DataSource({ store: this.products, paginate: true });
        await this.appInfo.pleaseWaitHide();
    }

    productChanged = (e: any) => {
        const product = this.products.find((p) => p.id === e.value);
        this.invoiceLine.partNumber = product?.partNumber;
        this.invoiceLine.unit = product?.inventoryUom.name;
        this.invoiceLine.price = product?.basePrice;
        this.invoiceLine.description = product?.description;
    };

    save() {
        const success = this.valid();
        if (!success) return;

        this.result.next({ success: true, value: this.invoiceLine });
    }

    cancel() {
        this.invoiceLine.entityAspect.rejectChanges();

        this.result.next({ success: false });
    }

    valid() {
        const groupConfig = validationEngine.getGroupConfig('invoiceLineValidationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('invoiceLineValidationGroup');
            return result.isValid;
        } else return false;
    }
}
